import React from "react";
import { Box } from "@mui/material";
import LoginBox from "~/presentation/components/LoginBox";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
    const navigate = useNavigate();

    return (
        <Box sx={styles.container}>
            <Box sx={styles.leftSide}>
                <LoginBox navigate={navigate} />
            </Box>
            <Box sx={styles.rightSide} />
        </Box>
    );
};

export default LoginPage;

const styles = {
    container: {
        display: "flex",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
    },
    leftSide: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f4f6f8",
        padding: { xs: 2, md: 4 },
    },
    rightSide: {
        flex: 1,
        display: { xs: "none", md: "flex" },
        backgroundImage: "url('/assets/login-bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
    }
};
